<section
  class="gmail-compose bg-foreground text-default shadow-2xl rounded-t border"
  [class.gmail-compose--maximized]="maximized"
  [class.gmail-compose--minimized]="minimized">
  <div class="gmail-compose__title flex items-center px-4 py-2 bg-primary-600 text-white rounded-t">
    <p class="flex-1 text-sm font-medium truncate">{{ title }}</p>
    <button (click)="toggleMinimize()" class="gmail-compose__window-button" mat-icon-button matTooltip="Minimize" type="button">
      <mat-icon [svgIcon]="minimized ? 'mat:open_in_full' : 'mat:minimize'"></mat-icon>
    </button>
    <button (click)="toggleMaximize()" class="gmail-compose__window-button" mat-icon-button [matTooltip]="maximized ? 'Restore' : 'Full screen'" type="button">
      <mat-icon [svgIcon]="maximized ? 'mat:close_fullscreen' : 'mat:open_in_full'"></mat-icon>
    </button>
    <button (click)="requestClose()" [disabled]="sending || savingDraft" class="gmail-compose__window-button" mat-icon-button matTooltip="Close" type="button">
      <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
  </div>

  <mat-progress-bar *ngIf="sending || savingDraft" mode="indeterminate"></mat-progress-bar>

  <form [formGroup]="form" [class.gmail-compose__body--hidden]="minimized" class="gmail-compose__body">
    <div class="gmail-compose__fields">
      <div class="px-4 pt-3 text-xs text-secondary" *ngIf="effectiveFromEmail">
        From {{ effectiveFromEmail }}
      </div>

      <div class="gmail-compose__recipients px-4">
        <div class="gmail-compose__recipient-row" [class.gmail-compose__recipient-row--invalid]="form.get('to')?.invalid && form.get('to')?.touched">
          <label>To</label>
          <div class="gmail-compose__chips" (click)="activateRecipientField('to')">
            <ng-container *ngFor="let recipient of toRecipients; let index = index">
              <span
                *ngIf="!isEditing('to', index); else editToRecipient"
                (dblclick)="startEditRecipient('to', index)"
                [class.gmail-compose__chip--invalid]="isInvalidEmail(recipient)"
                class="gmail-compose__chip">
                {{ recipient }}
                <button (click)="removeRecipient('to', index)" type="button">
                  <mat-icon svgIcon="mat:close"></mat-icon>
                </button>
              </span>
              <ng-template #editToRecipient>
                <input
                  [(ngModel)]="editValue"
                  [ngModelOptions]="{ standalone: true }"
                  (blur)="commitRecipientEdit()"
                  (keydown.enter)="commitRecipientEdit()"
                  class="gmail-compose__chip-edit"
                  type="text" />
              </ng-template>
            </ng-container>

            <input
              [(ngModel)]="toDraft"
              [ngModelOptions]="{ standalone: true }"
              (blur)="onRecipientBlur('to')"
              (focus)="activateRecipientField('to')"
              (input)="activateRecipientField('to')"
              (keydown)="onRecipientKeydown($event, 'to')"
              (paste)="onRecipientPaste($event, 'to')"
              placeholder="Recipients"
              type="text" />
          </div>
          <button (click)="onCcBccToggle()" color="primary" mat-button type="button">CC/BCC</button>
        </div>
        <p *ngIf="form.get('to')?.invalid && form.get('to')?.touched" class="gmail-compose__error">Enter at least one valid email address.</p>
        <div *ngIf="showSuggestionList('to')" class="gmail-compose__suggestions-list">
          <button
            *ngFor="let suggestion of suggestedRecipients('to'); let index = index"
            (mouseenter)="highlightedSuggestionIndex.to = index"
            (pointerdown)="onSuggestionPointerDown($event, 'to', suggestion)"
            [class.gmail-compose__suggestion-row--active]="isSuggestionHighlighted('to', index)"
            class="gmail-compose__suggestion-row"
            type="button">
            <span class="gmail-compose__suggestion-avatar">{{ suggestion.initials }}</span>
            <span class="gmail-compose__suggestion-content">
              <span class="gmail-compose__suggestion-main">{{ suggestion.name }}</span>
              <span class="gmail-compose__suggestion-email">{{ suggestion.email }}</span>
            </span>
            <span class="gmail-compose__suggestion-sub">{{ suggestion.caption }}</span>
          </button>
        </div>
      </div>

      <div [@dropdown]="dropdownOpen" class="overflow-hidden">
        <div class="gmail-compose__recipients px-4">
          <div class="gmail-compose__recipient-row" [class.gmail-compose__recipient-row--invalid]="form.get('cc')?.invalid">
            <label>Cc</label>
            <div class="gmail-compose__chips" (click)="activateRecipientField('cc')">
              <ng-container *ngFor="let recipient of ccRecipients; let index = index">
                <span
                  *ngIf="!isEditing('cc', index); else editCcRecipient"
                  (dblclick)="startEditRecipient('cc', index)"
                  [class.gmail-compose__chip--invalid]="isInvalidEmail(recipient)"
                  class="gmail-compose__chip">
                  {{ recipient }}
                  <button (click)="removeRecipient('cc', index)" type="button">
                    <mat-icon svgIcon="mat:close"></mat-icon>
                  </button>
                </span>
                <ng-template #editCcRecipient>
                  <input
                    [(ngModel)]="editValue"
                    [ngModelOptions]="{ standalone: true }"
                    (blur)="commitRecipientEdit()"
                    (keydown.enter)="commitRecipientEdit()"
                    class="gmail-compose__chip-edit"
                    type="text" />
                </ng-template>
              </ng-container>

              <input
                [(ngModel)]="ccDraft"
                [ngModelOptions]="{ standalone: true }"
                (blur)="onRecipientBlur('cc')"
                (focus)="activateRecipientField('cc')"
                (input)="activateRecipientField('cc')"
                (keydown)="onRecipientKeydown($event, 'cc')"
                (paste)="onRecipientPaste($event, 'cc')"
                placeholder="Cc recipients"
                type="text" />
            </div>
          </div>
          <p *ngIf="form.get('cc')?.invalid" class="gmail-compose__error">Cc has an invalid email address.</p>
          <div *ngIf="showSuggestionList('cc')" class="gmail-compose__suggestions-list">
            <button
              *ngFor="let suggestion of suggestedRecipients('cc'); let index = index"
              (mouseenter)="highlightedSuggestionIndex.cc = index"
              (pointerdown)="onSuggestionPointerDown($event, 'cc', suggestion)"
              [class.gmail-compose__suggestion-row--active]="isSuggestionHighlighted('cc', index)"
              class="gmail-compose__suggestion-row"
              type="button">
              <span class="gmail-compose__suggestion-avatar">{{ suggestion.initials }}</span>
              <span class="gmail-compose__suggestion-content">
                <span class="gmail-compose__suggestion-main">{{ suggestion.name }}</span>
                <span class="gmail-compose__suggestion-email">{{ suggestion.email }}</span>
              </span>
              <span class="gmail-compose__suggestion-sub">{{ suggestion.caption }}</span>
            </button>
          </div>

          <div class="gmail-compose__recipient-row" [class.gmail-compose__recipient-row--invalid]="form.get('bcc')?.invalid">
            <label>Bcc</label>
            <div class="gmail-compose__chips" (click)="activateRecipientField('bcc')">
              <ng-container *ngFor="let recipient of bccRecipients; let index = index">
                <span
                  *ngIf="!isEditing('bcc', index); else editBccRecipient"
                  (dblclick)="startEditRecipient('bcc', index)"
                  [class.gmail-compose__chip--invalid]="isInvalidEmail(recipient)"
                  class="gmail-compose__chip">
                  {{ recipient }}
                  <button (click)="removeRecipient('bcc', index)" type="button">
                    <mat-icon svgIcon="mat:close"></mat-icon>
                  </button>
                </span>
                <ng-template #editBccRecipient>
                  <input
                    [(ngModel)]="editValue"
                    [ngModelOptions]="{ standalone: true }"
                    (blur)="commitRecipientEdit()"
                    (keydown.enter)="commitRecipientEdit()"
                    class="gmail-compose__chip-edit"
                    type="text" />
                </ng-template>
              </ng-container>

              <input
                [(ngModel)]="bccDraft"
                [ngModelOptions]="{ standalone: true }"
                (blur)="onRecipientBlur('bcc')"
                (focus)="activateRecipientField('bcc')"
                (input)="activateRecipientField('bcc')"
                (keydown)="onRecipientKeydown($event, 'bcc')"
                (paste)="onRecipientPaste($event, 'bcc')"
                placeholder="Bcc recipients"
                type="text" />
            </div>
          </div>
          <p *ngIf="form.get('bcc')?.invalid" class="gmail-compose__error">Bcc has an invalid email address.</p>
          <div *ngIf="showSuggestionList('bcc')" class="gmail-compose__suggestions-list">
            <button
              *ngFor="let suggestion of suggestedRecipients('bcc'); let index = index"
              (mouseenter)="highlightedSuggestionIndex.bcc = index"
              (pointerdown)="onSuggestionPointerDown($event, 'bcc', suggestion)"
              [class.gmail-compose__suggestion-row--active]="isSuggestionHighlighted('bcc', index)"
              class="gmail-compose__suggestion-row"
              type="button">
              <span class="gmail-compose__suggestion-avatar">{{ suggestion.initials }}</span>
              <span class="gmail-compose__suggestion-content">
                <span class="gmail-compose__suggestion-main">{{ suggestion.name }}</span>
                <span class="gmail-compose__suggestion-email">{{ suggestion.email }}</span>
              </span>
              <span class="gmail-compose__suggestion-sub">{{ suggestion.caption }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="gmail-compose__subject px-4">
        <input formControlName="subject" placeholder="Subject" type="text" />
      </div>
    </div>

    <div class="gmail-compose__editor-scroll">
      <div class="vex-mail-compose-editor flex flex-col px-4">
        <div class="mail-editor rounded border">
          <div class="mail-editor__toolbar">
            <button (click)="format('bold')" mat-icon-button matTooltip="Bold" type="button">
              <mat-icon svgIcon="mat:format_bold"></mat-icon>
            </button>
            <button (click)="format('italic')" mat-icon-button matTooltip="Italic" type="button">
              <mat-icon svgIcon="mat:format_italic"></mat-icon>
            </button>
            <button (click)="format('underline')" mat-icon-button matTooltip="Underline" type="button">
              <mat-icon svgIcon="mat:format_underlined"></mat-icon>
            </button>
            <button (click)="format('strikeThrough')" mat-icon-button matTooltip="Strike" type="button">
              <mat-icon svgIcon="mat:strikethrough_s"></mat-icon>
            </button>

            <span class="mail-editor__divider"></span>

            <select (change)="setFontSize($any($event.target).value)" title="Text size">
              <option value="">Size</option>
              <option value="2">Small</option>
              <option value="3">Normal</option>
              <option value="4">Large</option>
              <option value="5">Huge</option>
            </select>
            <label class="mail-editor__color" matTooltip="Text color">
              <mat-icon svgIcon="mat:format_color_text"></mat-icon>
              <input (input)="format('foreColor', $any($event.target).value)" type="color" />
            </label>
            <label class="mail-editor__color" matTooltip="Highlight">
              <mat-icon svgIcon="mat:format_color_fill"></mat-icon>
              <input (input)="format('backColor', $any($event.target).value)" type="color" />
            </label>

            <span class="mail-editor__divider"></span>

            <button (click)="format('justifyLeft')" mat-icon-button matTooltip="Align left" type="button">
              <mat-icon svgIcon="mat:format_align_left"></mat-icon>
            </button>
            <button (click)="format('justifyCenter')" mat-icon-button matTooltip="Align center" type="button">
              <mat-icon svgIcon="mat:format_align_center"></mat-icon>
            </button>
            <button (click)="format('justifyRight')" mat-icon-button matTooltip="Align right" type="button">
              <mat-icon svgIcon="mat:format_align_right"></mat-icon>
            </button>
            <button (click)="format('insertUnorderedList')" mat-icon-button matTooltip="Bullet list" type="button">
              <mat-icon svgIcon="mat:format_list_bulleted"></mat-icon>
            </button>
            <button (click)="format('insertOrderedList')" mat-icon-button matTooltip="Numbered list" type="button">
              <mat-icon svgIcon="mat:format_list_numbered"></mat-icon>
            </button>

            <span class="mail-editor__divider"></span>

            <button (click)="createLink()" mat-icon-button matTooltip="Link" type="button">
              <mat-icon svgIcon="mat:link"></mat-icon>
            </button>
            <input #inlineImageInput (change)="insertInlineImage(inlineImageInput.files); inlineImageInput.value = ''" accept="image/*" hidden type="file" />
            <button (click)="inlineImageInput.click()" mat-icon-button matTooltip="Insert image" type="button">
              <mat-icon svgIcon="mat:image"></mat-icon>
            </button>
            <button (click)="format('removeFormat')" mat-icon-button matTooltip="Clear formatting" type="button">
              <mat-icon svgIcon="mat:format_clear"></mat-icon>
            </button>
          </div>

          <div
            #editor
            (input)="onEditorInput()"
            (blur)="onEditorInput()"
            (click)="focusEditor()"
            class="mail-editor__surface"
            contenteditable="true"
            data-placeholder="Write your message..."></div>
        </div>
      </div>
    </div>

    <div class="gmail-compose__attachments px-4" *ngIf="files.length > 0">
      <div
        *ngFor="let file of files; let index = index"
        class="vex-mail-compose-attachment my-2 rounded-full border px-4 py-1 flex items-center hover:bg-hover transition duration-200 ease-in-out">
        <mat-icon class="flex-none text-primary-600 icon-sm" svgIcon="mat:attach_file"></mat-icon>
        <p class="flex-auto ml-4 text-sm truncate">{{ file.name }}</p>
        <p class="text-sm text-secondary mr-2 flex-none">{{ file.size / 1024 | number: '1.0-0' }}kb</p>
        <button (click)="removeFile(index)" class="flex-none w-8 h-8 p-0 leading-none" mat-icon-button type="button">
          <mat-icon class="icon-sm" svgIcon="mat:close"></mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="forwardingAttachments" class="px-4 pb-3 text-xs text-secondary">
      Loading forwarded attachments...
    </div>
  </form>

  <div [class.gmail-compose__footer--hidden]="minimized" class="gmail-compose__footer flex items-center gap-2 px-4 py-3 border-t">
    <button (click)="requestDiscard()" [disabled]="sending || savingDraft" color="warn" mat-icon-button matTooltip="Discard Draft" type="button">
      <mat-icon svgIcon="mat:delete"></mat-icon>
    </button>

    <span *ngIf="draftStatus" class="gmail-compose__draft-status">{{ draftStatus }}</span>

    <span class="flex-1"></span>

    <input #fileInput (change)="attach(fileInput.files); fileInput.value = ''" multiple hidden type="file" />
    <button (click)="fileInput.click()" mat-icon-button matTooltip="Attach File" type="button">
      <mat-icon svgIcon="mat:attach_file"></mat-icon>
    </button>

    <button (click)="submit()" [disabled]="sending || savingDraft || form.invalid || (!account && !isTemplateDraft)" color="primary" mat-flat-button type="button">
      <span>Send</span>
      <mat-icon class="ml-2 icon-sm" svgIcon="mat:send"></mat-icon>
    </button>
  </div>
</section>
